var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
// tslint:disable:max-line-length
// This file is generated by generateStyles script.
// Please don't edit it manually.
import * as React from "react";
import "../../less/svg/ContractNote.less";
export var ContractNote = function (props) { return (React.createElement("svg", { viewBox: "0 0 107.22 113.74" },
    React.createElement("defs", null),
    React.createElement("g", __assign({ id: "Layer_2" }, props, { className: "ContractNote " + props.className }),
        React.createElement("g", { id: "_-market", "data-name": "-market" },
            React.createElement("path", { id: "note-highlight", className: "cls-1", d: "M6.39 113.74l-.14-3.15-1.86.15L0 10.61C12.3 9.15 24.66 8.2 37 7.4 34.77-2.59 53.92-1.88 49.84 6l.1.24a7.45 7.45 0 0 1 1.59.27C67.26 5.74 83 5.29 98.75 5.07v3h2c0 29.38 3.34 59 5.58 88.24q.44 5.75.89 11.49c-30.18 0-60.45 2.79-90.52 5.12z" }),
            React.createElement("path", { id: "note-shadow", className: "cls-2", d: "M4.6 15.82s37.3-4.43 93.65-5.22c0 14.87 6.26 94.7 6.26 94.7-25 0-95.74 5.74-95.74 5.74z" }),
            React.createElement("path", { id: "note_container", "data-name": "note#container", className: "cls-3", d: "M2.6 12.82S39.9 8.39 96.25 7.6c0 14.87 6.26 94.7 6.26 94.7-25 0-95.74 5.74-95.74 5.74z" }),
            React.createElement("path", { id: "pin-shape", className: "cls-5", d: "M43 16.51a3.2 3.2 0 0 1 .83-5.06l-1.3-3S40 8.71 39.49 7s.39-3.15 3.13-4.44C46 1 49.4 3.62 47 5.65a30.92 30.92 0 0 0 1.44 3.26 4.24 4.24 0 0 1 4.69 1.82c2.47 3.9-6.89 9.79-10.13 5.78z" }),
            React.createElement("path", { id: "pin-shine", className: "cls-6", d: "M46.46 3s-.58 2.41-2.34 3.26c1.44.04 4.49-1.85 2.34-3.26z" }),
            React.createElement("path", { id: "pin-shine-2", "data-name": "pin-shine", className: "cls-6", d: "M46 7.08s1 3 3 4.31a6.22 6.22 0 0 0-3-4.31z" }),
            React.createElement("path", { id: "pin-shine-3", "data-name": "pin-shine", className: "cls-6", d: "M52 11.39a6 6 0 0 1-3 4.43c1.51-.07 5.56-3.65 3-4.43z" }),
            React.createElement("path", { id: "pin-needle", className: "cls-4", d: "M48.95 16.44l2.58 2.64-1.02-3.88-1.56 1.24z" }))))); };



//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/ContractNote.tsx
// module id = 2721
// module chunks = 3